import type { Customer } from '~/models/customer'

export const useCustomerLocalStorage = () => {
  const localStorageKey = 'checkoutCustomer'

  const getCustomerFromLocalStorage = (): Customer | null => {
    const raw = localStorage.getItem(localStorageKey)
    if (!raw) return null

    try {
      const parsed = JSON.parse(raw)

      return {
        firstName: String(parsed.firstName ?? ''),
        lastName: String(parsed.lastName ?? ''),
        email: String(parsed.email ?? ''),
        phone: String(parsed.phone ?? ''),
        address: String(parsed.address ?? ''),
        city: String(parsed.city ?? ''),
        state: String(parsed.state ?? ''),
        zip: String(parsed.zip ?? ''),
        country: String(parsed.country ?? ''),
        address2: String(parsed.address2 ?? ''),
      }
    }
    catch (error) {
      console.warn('Failed to parse customer from localStorage:', error)
      return null
    }
  }

  const saveCustomerToLocalStorage = (customer: Customer): void => {
    localStorage.setItem(localStorageKey, JSON.stringify(customer))
  }

  const clearCustomer = (): void => {
    localStorage.removeItem(localStorageKey)
  }

  return {
    getCustomerFromLocalStorage,
    saveCustomerToLocalStorage,
    clearCustomer,
  }
}
